import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/layouts/AppShell";

import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientsPage from "@/pages/ClientsPage";
import MattersPage from "@/pages/MattersPage";
import MatterDetailPage from "@/pages/MatterDetailPage";
import TasksPage from "@/pages/TasksPage";
import DocumentsPage from "@/pages/DocumentsPage";
import CommunicationsPage from "@/pages/CommunicationsPage";
import BillingPage from "@/pages/BillingPage";
import ReportsPage from "@/pages/ReportsPage";
import UsersPage from "@/pages/UsersPage";

import "@/App.css";

const Shell = (page) => (
  <ProtectedRoute>
    <AppShell>{page}</AppShell>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={Shell(<DashboardPage />)} />
          <Route path="/clients" element={Shell(<ClientsPage />)} />
          <Route path="/matters" element={Shell(<MattersPage />)} />
          <Route path="/matters/:id" element={Shell(<MatterDetailPage />)} />
          <Route path="/tasks" element={Shell(<TasksPage />)} />
          <Route path="/documents" element={Shell(<DocumentsPage />)} />
          <Route path="/communications" element={Shell(<CommunicationsPage />)} />
          <Route path="/billing" element={Shell(<BillingPage />)} />
          <Route path="/reports" element={Shell(<ReportsPage />)} />
          <Route
            path="/users"
            element={
              <ProtectedRoute roles={["partner"]}>
                <AppShell><UsersPage /></AppShell>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
